module.exports = "<div id=\"content\">\n  <div class=\"form-group row\">\n    <label class=\"col-sm-7 control-label col-md-offset-2\"><h2 [translate]=\"'LOGOUT.TITLE'\"></h2></label>\n  </div>\n  <div class=\"form-group row\">\n    <p [translate]=\"'LOGOUT.REDIRECT'\"></p>\n  </div>\n  <div class=\"form-group row\">\n    <message-box [messages]=\"errorMessages\"></message-box>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout-keycloak/logout-keycloak.component.html
// module id = ./src/app/logout-keycloak/logout-keycloak.component.html
// module chunks = main